import { useEffect, useState } from "react";
import { ArrowUp, CornerUpLeft, CornerUpRight, Fence, Home } from "lucide-react";

const cn = (...classes) => classes.filter(Boolean).join(" ");

export const testDirectionProps = {
  directionValues: [
    {
      distance: "Grille",
      direction: "fence",
      to: "",
      iconType: Fence,
    },
    {
      distance: 50,
      direction: "straight",
      to: "Allée pavée",
      iconType: ArrowUp,
    },

    {
      distance: 5,
      direction: "right",
      to: "Salle d'attente",
      iconType: CornerUpRight,
    },
    {
      distance: "Cabinet",
      direction: "cabinet",
      to: "",
      iconType: Home,
    },
  ],
};

function DirectionCard({
  directionValues = testDirectionProps.directionValues,
  duration = 5000,
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [iconState, setIconState] = useState({
    prevIconType: directionValues[directionValues.length - 1].iconType,
    currentIconType: directionValues[0].iconType,
    nextIconType: directionValues[1].iconType,
  });
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    //this would change the states based on direction change. Currently set to setInterval.
    const changeDirectionInterval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const newIndex = (prevIndex + 1) % directionValues.length;
        const prev =
          newIndex === 0
            ? directionValues[directionValues.length - 1].iconType
            : directionValues[newIndex - 1].iconType;
        const next =
          newIndex === directionValues.length - 1
            ? directionValues[0].iconType
            : directionValues[newIndex + 1].iconType;
        setIconState({
          prevIconType: prev,
          currentIconType: directionValues[newIndex].iconType,
          nextIconType: next,
        });
        return newIndex;
      });
      setProgress(0);
    }, duration ?? 5000);

    const progressIncrement = 100 / ((duration ?? 5000) / 100);
    const progressInterval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          return 100;
        }
        return prevProgress + progressIncrement;
      });
    }, 100);

    return () => {
      clearInterval(changeDirectionInterval);
      clearInterval(progressInterval);
    };
  }, [directionValues, duration]);

  const currentDirection = directionValues[currentIndex];

  const renderIcon = (IconComponent, size = 52, color = "text-gray-600", customColor = null) => (
    <IconComponent 
      size={size} 
      className={customColor ? "" : cn("text-black", color)}
      style={customColor ? { color: customColor } : {}}
    />
  );
  
  return (
    <div className="direction-card flex size-52 items-start justify-between rounded-3xl bg-white p-4">
      <div className="direction-container flex h-full w-[80%] flex-col items-center justify-center gap-3">
        <p className="text-3xl font-bold text-black">
          {currentDirection.distance}
          {typeof currentDirection.distance === 'number' && <span className="text-opacity-50">m</span>}
        </p>
        <p className="animate-pulse">{renderIcon(iconState.currentIconType, 52, "text-black")}</p>
        <p className="text-md h-8 w-20 text-ellipsis break-words text-center text-gray-600">
          {currentDirection.to}
        </p>
      </div>
      <div className="progress-icon-container flex h-full w-[100px] flex-row-reverse justify-around">
        <div className="relative flex flex-col justify-evenly">
          <div
            style={{ boxShadow: "inset 0px -30px 20px 0px white" }}
            className="absolute inset-0 shadow"
          />
          {renderIcon(iconState.nextIconType, 32)}
          {renderIcon(iconState.currentIconType, 32, "text-black", "#FF9FFC")}
          {renderIcon(iconState.prevIconType, 32)}
        </div>
        <div
          style={{ height: "100%" }}
          className="progress-bar flex h-full w-[6px] items-end rounded-xl bg-gray-300"
        >
          <div
            style={{ height: `${progress}%`, backgroundColor: '#FF9FFC' }}
            className="progress-bar h-full w-[6px] rounded-xl shadow-glow2"
          />
        </div>
      </div>
    </div>
  );
}

export default DirectionCard;
